module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    attrs: {
      "id": "container"
    }
  }), _vm._v(" "), (_vm.contentDetail) ? _c('div', {
    staticClass: "container"
  }, [(_vm.contentDetail.taskstauts == '已取消' || (_vm.contentDetail.taskstauts == '待执行' && !_vm.isStart) || _vm.contentDetail.taskstauts == '已结束') ? _c('div', {
    staticClass: "tab-box"
  }, [_c('div', {
    staticClass: "title-box flex justify-between align-center"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [(_vm.contentDetail.taskstauts == '待执行') ? _c('image', {
    staticClass: "share-icon margin-bottom-xs",
    attrs: {
      "src": "https://sass.gclme.com/api/file/Image/annex/20220425_8b85ce80009e45f8ab3f2ef172723de4.png",
      "mode": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('image', {
    staticClass: "share-icon margin-bottom-xs",
    attrs: {
      "src": "https://sass.gclme.com/api/file/Image/annex/20220425_042ce2fc4fa74dc8b0d9f13d51acf0e3.png",
      "mode": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '已取消') ? _c('image', {
    staticClass: "share-icon margin-bottom-xs",
    attrs: {
      "src": "https://sass.gclme.com/api/file/Image/annex/20220425_e3e938a6205e452aa1b2cb983472085f.png",
      "mode": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "color333"
  }, [_vm._v(_vm._s(_vm.contentDetail.taskstauts))])])]), _vm._v(" "), _c('div', {
    staticClass: "inner-box"
  }, [_c('p', {
    staticClass: "color666"
  }, [_vm._v("任务编号:" + _vm._s(_vm.contentDetail.taskcode))]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-derection alladress-box"
  }, [_c('div', {
    staticClass: "flex align-center"
  }, [_c('div', {
    staticClass: "adress-icon flex justify-center align-center"
  }, [_vm._v("出")]), _vm._v(" "), _c('div', {
    staticClass: "max-width560"
  }, [_vm._v("\n              " + _vm._s(_vm.contentDetail.planDeliveryAddress) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex box-center"
  }, [_c('div', {
    staticClass: "adress-icon adress-icon006DFF flex justify-center align-center"
  }, [_vm._v("到")]), _vm._v(" "), _c('div', {
    staticClass: "max-width560"
  }, [_vm._v("\n              " + _vm._s(_vm.contentDetail.planConsignAddress) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "adress-icon adress-icon3DBFFF flex justify-center align-center"
  }, [_vm._v("收")]), _vm._v(" "), _c('div', {
    staticClass: "max-width560"
  }, [_vm._v("\n              " + _vm._s(_vm.contentDetail.planCollectAddress) + "\n            ")])])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("计划开始时间")]), _vm._v(_vm._s(_vm.contentDetail.planstartdatetime))]), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("出发时间")]), _vm._v(_vm._s(_vm.contentDetail.startdatetime))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("计划到货时间")]), _vm._v(_vm._s(_vm.contentDetail.plandatetime))]), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("到货时间")]), _vm._v(_vm._s(_vm.contentDetail.enddeliverytime))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("计划结束时间")]), _vm._v(_vm._s(_vm.contentDetail.planenddatetime))]), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("收车时间")]), _vm._v(_vm._s(_vm.contentDetail.collectdatetime))]) : _vm._e(), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("车牌号码")]), _vm._v(_vm._s(_vm.contentDetail.licenseplate))]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("货品名称")]), _vm._v(_vm._s(_vm.contentDetail.cargoname))]), _vm._v(" "), (_vm.contentDetail.taskstauts == '待执行' && !_vm.isStart) ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("收货人")]), _vm._v(_vm._s(_vm.contentDetail.consignee))]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '待执行' && !_vm.isStart) ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("联系电话")]), _vm._v(_vm._s(_vm.contentDetail.phone))]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("耗时")]), _vm._v(_vm._s(_vm.contentDetail.timeconsuming))]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("超出计划时长")]), _vm._v(_vm._s(_vm.contentDetail.timelong))]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束') ? _c('p', [_c('span', {
    staticClass: "left-width"
  }, [_vm._v("里程")]), _vm._v(_vm._s(_vm.contentDetail.surplusMileage))]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '已结束' && _vm.contentDetail.gclTransportActuTaskAlarmEntityList && _vm.contentDetail.gclTransportActuTaskAlarmEntityList.length > 0) ? _c('div', {
    staticClass: "tab-box",
    on: {
      "click": function($event) {
        return _vm.giveAlarm()
      }
    }
  }, [_c('div', {
    staticClass: "inner-box"
  }, [_c('p', [_vm._v("告警信息总数:" + _vm._s(_vm.contentDetail.gclTransportActuTaskAlarmEntityList.length))]), _vm._v(" "), _vm._l((_vm.contentDetail.gclTransportActuTaskAlarmEntityList), function(item, index) {
    return _c('p', {
      key: index
    }, [_vm._v("告警信息" + _vm._s(index + 1) + ":" + _vm._s(item.alarmreason))])
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '执行中' || _vm.isStart) ? _c('div', {
    staticClass: "tab-box"
  }, [_c('div', {
    staticClass: "title-box flex align-center"
  }, _vm._l((_vm.typeList), function(item, index) {
    return _c('div', {
      key: index,
      class: index == _vm.TabCur ? 'text text-block' : 'text',
      on: {
        "click": function($event) {
          return _vm.filterArr(index)
        }
      }
    }, [_vm._v(_vm._s(item))])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "inner-box"
  }, [_c('div', {
    staticClass: "inner-box-tab flex flex-derection"
  }, [_c('div', {
    staticClass: "inner-box-go"
  }, [_c('div', {}, [_vm._v("\n              当前SOC:" + _vm._s(_vm.contentDetail.soc) + "%\n            ")]), _vm._v(" "), _c('div', {}, [(_vm.contentDetail.isShowLow) ? _c('div', {
    staticClass: "inner-box-red"
  }, [_vm._v("\n                电量低\n              ")]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.isShow) ? _c('div', {
    staticClass: "inner-box-blue",
    on: {
      "click": function($event) {
        return _vm.goChange()
      }
    }
  }, [_vm._v("\n                去换电\n              ")]) : _vm._e()])]), _vm._v(" "), _c('p', [_vm._v("距任务结束剩余里程:" + _vm._s(_vm.TabCur == 0 ? _vm.contentDetail.surplusMileage : (_vm.TabCur == 1 ? _vm.contentDetail.goMileage : _vm.contentDetail.backMileage)) + "（km）")]), _vm._v(" "), _c('p', [_vm._v("距任务结束剩余时长:" + _vm._s(_vm.TabCur == 0 ? _vm.contentDetail.timelong : (_vm.TabCur == 1 ? _vm.contentDetail.gotime : _vm.contentDetail.backtime)) + "h")])])])]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '执行中' || _vm.isStart) ? _c('div', {
    staticClass: "adress-box flex flex-derection"
  }, [_c('div', {
    staticClass: "adress"
  }, [(_vm.contentDetail.collectdatetime) ? _c('img', {
    staticClass: "adress-loc-icon",
    attrs: {
      "src": require("../../../static/images/shouche.png")
    }
  }) : _c('img', {
    staticClass: "adress-loc-icon",
    attrs: {
      "src": require("../../../static/images/shouche-no.png")
    }
  }), _vm._v(" "), (_vm.contentDetail.collectdatetime) ? _c('div', {
    staticClass: "flex flex-derection"
  }, [_c('div', {
    staticClass: "time-box flex align-center"
  }, [_c('span', [_vm._v("已到达")]), _vm._v(_vm._s(_vm.contentDetail.collectdatetime) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "adress-get color333"
  }, [_vm._v("[收车地址]" + _vm._s(_vm.contentDetail.planCollectAddress))])]) : _c('div', {
    staticClass: "flex"
  }, [_c('p', {
    staticClass: "adress-get"
  }, [_vm._v("[收车地址]" + _vm._s(_vm.contentDetail.planCollectAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "adress"
  }, [(_vm.contentDetail.enddeliverytime) ? _c('img', {
    staticClass: "adress-loc-icon",
    attrs: {
      "src": require("../../../static/images/shouhuo.png")
    }
  }) : _c('img', {
    staticClass: "adress-loc-icon",
    attrs: {
      "src": require("../../../static/images/shouhuo-no.png")
    }
  }), _vm._v(" "), (_vm.contentDetail.enddeliverytime) ? _c('div', {
    staticClass: "flex flex-derection"
  }, [_c('div', {
    staticClass: "time-box flex align-center"
  }, [_c('span', [_vm._v("已到达")]), _vm._v(_vm._s(_vm.contentDetail.enddeliverytime) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "adress-get color333"
  }, [_vm._v("[收货地址]" + _vm._s(_vm.contentDetail.planConsignAddress))])]) : _c('div', {
    staticClass: "flex"
  }, [_c('p', {
    staticClass: "adress-get"
  }, [_vm._v("[收货地址]" + _vm._s(_vm.contentDetail.planConsignAddress))])])]), _vm._v(" "), _c('div', {
    staticClass: "adress"
  }, [_c('img', {
    staticClass: "adress-loc-icon",
    attrs: {
      "src": require("../../../static/images/go.png")
    }
  }), _vm._v(" "), (_vm.contentDetail.startdatetime) ? _c('div', {
    staticClass: "flex flex-derection"
  }, [_c('div', {
    staticClass: "time-box flex align-center"
  }, [_c('span', [_vm._v("准备出发")]), _vm._v(_vm._s(_vm.contentDetail.startdatetime) + "\n          ")]), _vm._v(" "), _c('p', {
    staticClass: "adress-get color333"
  }, [_vm._v(_vm._s(_vm.contentDetail.planDeliveryAddress))])]) : _c('div', {
    staticClass: "flex"
  }, [_c('p', {
    staticClass: "adress-get"
  }, [_vm._v(_vm._s(_vm.contentDetail.planDeliveryAddress))])])])]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '执行中' || _vm.isStart) ? _c('div', {
    staticClass: "adress-button"
  }, [(_vm.lookText == '打卡') ? _c('div', {
    staticClass: "get-adress",
    on: {
      "click": function($event) {
        return _vm.isRange()
      }
    }
  }, [_vm._v(_vm._s(_vm.lookText))]) : _c('div', {
    staticClass: "get-adress get-adress-dis"
  }, [_vm._v(_vm._s(_vm.lookText))]), _vm._v(" "), _c('div', {
    staticClass: "get-adress",
    on: {
      "click": function($event) {
        return _vm.gomap()
      }
    }
  }, [_vm._v("开始导航")])]) : _vm._e(), _vm._v(" "), (_vm.contentDetail.taskstauts == '待执行' && !_vm.isStart) ? _c('div', {
    staticClass: "adress-button"
  }, [_c('div', {
    staticClass: "get-adress",
    on: {
      "click": function($event) {
        return _vm.goStart()
      }
    }
  }, [_vm._v("开始执行任务")])]) : _vm._e()]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-93c8f924"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mapwebview/mapwebview.vue
// module id = 524
// module chunks = 1